import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
    Paper,
    Title,
    Text,
    TextInput,
    PasswordInput,
    Button,
    Stack,
    Alert,
    Anchor,
} from '@mantine/core';
import { useAuth } from '../auth/AuthContext.jsx';
import { ApiError } from '../api/client.js';

export default function LoginPage() {
    const { status, user, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    function nextStep(u) {
        if (u.mustChangePassword) return '/change-password';
        if (!u.pdnAcceptedAt) return '/accept-pdn';
        return location.state?.from || '/';
    }

    // Если уже залогинен — на нужную страницу
    if (status === 'authed') {
        return <Navigate to={nextStep(user)} replace />;
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setError(null);
        setSubmitting(true);
        try {
            const u = await login(username.trim(), password);
            navigate(nextStep(u), { replace: true });
        } catch (err) {
            if (err instanceof ApiError) {
                setError(err.message);
            } else {
                setError('Не удалось войти. Попробуйте позже.');
            }
            setSubmitting(false);
        }
    };

    return (
        <Paper p="xl" radius="md" withBorder shadow="sm">
            <Stack gap="md">
                <div>
                    <Title order={2}>Вход</Title>
                    <Text size="sm" c="dimmed" mt={4}>
                        Введите логин и пароль, выданные администратором.
                    </Text>
                </div>

                <form onSubmit={onSubmit} autoComplete="off" noValidate>
                    <Stack gap="md">
                        <TextInput
                            label="Логин"
                            required
                            autoFocus
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.currentTarget.value)}
                            disabled={submitting}
                        />
                        <PasswordInput
                            label="Пароль"
                            required
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.currentTarget.value)}
                            disabled={submitting}
                        />
                        {error && (
                            <Alert color="red" variant="light" role="alert">
                                {error}
                            </Alert>
                        )}
                        <Button type="submit" loading={submitting} fullWidth size="md">
                            Войти
                        </Button>
                    </Stack>
                </form>

                <Text size="xs" c="dimmed" ta="center">
                    <Anchor component={Link} to="/policy">
                        Политика конфиденциальности
                    </Anchor>
                </Text>
            </Stack>
        </Paper>
    );
}
